import { useEffect, useState } from "react";
import { PLAYER_COLORS, serverNow } from "@/lib/api";
import { LAYER } from "@/lib/terrain";

// BOARD THIEF BANNER (RULES 16 OCT R2): shown over the board on every screen for about 3 s after a
// theft ("Uh-oh! Ana stole Ben's Urban Forest!") or a block ("Ben blocked Ana's Board Thief with a
// Protection Card!"); the swapped squares pulse. Driven by game.thief_banner (server time), so every
// online screen shows the same banner; a screen that loads later than 3 s after it shows nothing.
export const BANNER_MS = 3000;

// 3D BOARD: the pulses sit on the swapped squares' top faces (geom.vis).
export default function ThiefBanner({ banner, geom }) {
  const at = banner?.at ? new Date(banner.at).getTime() : 0;
  const left = () => (at ? at + BANNER_MS - serverNow() : 0);
  const [, bump] = useState(0);
  useEffect(() => {
    const ms = left();
    if (ms <= 0) return undefined;
    const id = setTimeout(() => bump((n) => n + 1), ms + 30);
    return () => clearTimeout(id);
  }, [banner?.seq, at]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!banner || left() <= 0) return null;
  const thief = <span style={{ color: PLAYER_COLORS[banner.thief_color], fontWeight: 800 }}>{banner.thief_name}</span>;
  const victim = <span style={{ color: PLAYER_COLORS[banner.victim_color], fontWeight: 800 }}>{banner.victim_name}</span>;
  const text = banner.kind === "blocked"
    ? <>{victim} blocked {thief}&apos;s Board Thief with a Protection Card!</>
    : <>Uh-oh! {thief} stole {victim}&apos;s {banner.piece}!</>;
  return (
    <>
      <div className="absolute inset-0 pointer-events-none" style={{ zIndex: LAYER.thief }}>
        {(banner.cells || []).map((k) => {
          const v = geom.vis(k);
          return <span key={k} data-testid={`thief-pulse-${k}`} className="thief-pulse absolute" style={{ left: v.left, top: v.top, width: v.width, height: v.height }} />;
        })}
      </div>
      <div className="absolute inset-x-0 flex justify-center pointer-events-none" style={{ top: "38%", zIndex: LAYER.thief + 1 }}>
        <div data-testid="thief-banner" data-kind={banner.kind} className="thief-banner-in" style={{ background: "var(--card)", color: "var(--ink)", border: "2px solid var(--ink)", borderRadius: 12, padding: "12px 20px", fontSize: 20, lineHeight: "26px", fontWeight: 700, boxShadow: "var(--shadow-card)", maxWidth: "90%", textAlign: "center" }}>
          {text}
        </div>
      </div>
    </>
  );
}
